import { useUserPreferences } from '../context/UserPreferencesContext';

// Hook helpers to format with global timezone/locale
export function useDateTimeFormatting() {
  const prefs = useUserPreferences();
  return {
    formatDate: prefs?.formatDate,
    formatDateTime: prefs?.formatDateTime,
  };
}

export function useNumberFormatting() {
  const prefs = useUserPreferences();
  return {
    formatNumber: prefs?.formatNumber,
    formatCurrency: prefs?.formatCurrency,
  };
}
